import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ProfileLayoutPageStore } from 'pages/conversations/pages/search/pages/profile/store/profileLayoutPageStore'

export const ProfileLayoutPageContext = createContext<ProfileLayoutPageStore | null>(null)

export const useProfileLayoutPageContext = () => {
  const context = useContext(ProfileLayoutPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ProfileLayoutPageContext')

  return context
}

type IProviderProfileLayoutPageProps = {
  value: ProfileLayoutPageStore
  children: ReactNode
}

export const ProviderProfileLayoutPage: FC<IProviderProfileLayoutPageProps> = ({
  value,
  children,
}) => {
  return (
    <ProfileLayoutPageContext.Provider value={value}>{children}</ProfileLayoutPageContext.Provider>
  )
}
